import Tabs from '@trilogy-ds/react/lib/components/tabs/Tabs';
import TabPanels from '@trilogy-ds/react/lib/components/tabs/tab-panels/TabPanels';
import TabPanel from '@trilogy-ds/react/lib/components/tabs/tab-panels/tab-panel/TabPanel';
import TabList from './tab-list';
import Tab from './tab-list/tab/Tab';
export * from '@trilogy-ds/react/lib/components/tabs/TabsProps';
export { Tab, TabList, TabPanel, TabPanels, Tabs };
//# sourceMappingURL=index.js.map